import React from 'react';
import ReactDOMServer from "react-dom/server";

export const toHtml = (thing) => {
  const htmlEntities = (string) => {
    // Makes text displayable in browsers
  return string
    .replace(/&/g,   '&amp;')
    .replace(/\\"/g, '&bsol;&quot;')
    .replace(/</g,   '&lt;')
    .replace(/>/g,   '&gt;');
  };

  const replacer = (match, p1, p2, p3, p4) => {
     // Converts the four parenthesized capture groups into HTML
     const part =       { indent: p1, key: p2, value: p3, end: p4 };
     const key =        '<span class=json-key>';
     const val =        '<span class=json-value>';
     const bool =       '<span class=json-boolean>';
     const str =        '<span class=json-string>';
     const isBool =     ['true', 'false'].includes(part.value);
     const valSpan =    /^"/.test(part.value) ? str : isBool ? bool : val;
     const findName =   /"([\w]+)": |(.*): /;
     const indentHtml = part.indent || '';
     const keyHtml =    part.key ? key + part.key.replace(findName, '$1$2') + '</span>: ' : '';
     const valueHtml =  part.value ? valSpan + part.value + '</span>' : '';
     const endHtml =    part.end || '';
     return indentHtml + keyHtml + valueHtml + endHtml;
  };

    const jsonLine = /^( *)("[^"]+": )?("[^"]*"|[\w.+-]*)?([{}[\],]*)?$/mg;
    return htmlEntities(JSON.stringify(thing, null, 4)).replace(jsonLine, replacer);
}

export const addIdsToTitles = (html) => {
  let parsed = html;
  if (typeof html !== 'string') {
    parsed = ReactDOMServer.renderToStaticMarkup(html);
    parsed.toString();
  }
  
  const el = document.createElement('html');
  el.innerHTML = parsed;
  const h1s = el.getElementsByTagName('h1');
  const h2s = el.getElementsByTagName('h2');
  const h3s = el.getElementsByTagName('h3');
  for (const h1 of h1s) {
    h1.setAttribute('id', slugify(h1.innerText));
  }
  for (const h2 of h2s) {
    h2.setAttribute('id', slugify(h2.innerText));
  }
  for (const h3 of h3s) {
    h3.setAttribute('id', slugify(h3.innerText));
  }
  return el.outerHTML;
}

export const slugify = (str) => {
  str = str.replace(/^\s+|\s+$/g, '');
  str = str.toLowerCase();
  var from = "ÁÄÂÀÃÅČÇĆĎÉĚËÈÊẼĔȆÍÌÎÏŇÑÓÖÒÔÕØŘŔŠŤÚŮÜÙÛÝŸŽáäâàãåčçćďéěëèêẽĕȇíìîïňñóöòôõøðřŕšťúůüùûýÿžþÞĐđßÆa·/_,:;";
  var to   = "AAAAAACCCDEEEEEEEEIIIINNOOOOOORRSTUUUUUYYZaaaaaacccdeeeeeeeeiiiinnooooooorrstuuuuuyyzbBDdBAa------";
  for (var i=0, l=from.length ; i<l ; i++) {
    str = str.replace(new RegExp(from.charAt(i), 'g'), to.charAt(i));
  }
  str = str.replace(/[^a-z0-9 -]/g, '')
  .replace(/\s+/g, '-')
  .replace(/-+/g, '-'); 
  return str;
}

export const toPlainText = (Elem) => {
  let plainText = ReactDOMServer.renderToString(<Elem />);
  plainText = plainText.replaceAll("</p>", " </p>");
  plainText = plainText.replaceAll("</h1>", " </h1>");
  plainText = plainText.replaceAll("</h2>", " </h2>");
  plainText = plainText.replaceAll("</h3>", " </h3>");
  plainText = plainText.replaceAll("</li>", " </li>");
  return stripHtml(plainText);
}

function stripHtml (html) {
  if (typeof window === 'undefined' || !window.document) {
    return html;
  }
  let temporalDivElement = document.createElement('div');
  temporalDivElement.innerHTML = html;
  return temporalDivElement.textContent || temporalDivElement.innerText || '';
}

// Cookie utility functions
export const getCookie = (name) => {
  if (typeof document === 'undefined') return null;
  
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(';').shift();
  return null;
};

// Strict pathname shape shared by the funnel-page attribution params — the
// app-side validation (hyperping server/controllers/users.js) applies the
// same regex before persisting, so anything looser would be dropped anyway.
export const isPagePath = (value) =>
  typeof value === 'string' && /^\/(?!\/)[\w\-\/.]{0,254}$/.test(value);

// Partner program referral code (?via=), same shape as the server's.
export const isReferralCode = (value) =>
  typeof value === 'string' && /^[a-z0-9](?:[a-z0-9-]{1,30})[a-z0-9]$/.test(value);

// Exit page = the page hosting the signup CTA. On /oauth-google (a transit
// page) the pathname is useless — fall back to the last real page remembered
// by gatsby-browser.js rememberExitPage().
export const getExitPage = () => {
  if (typeof window === 'undefined') return '';
  let p = window.location.pathname;
  if (p.indexOf('/oauth-google') === 0) {
    try { p = sessionStorage.getItem('hp_exit_page') || ''; } catch (e) { p = ''; }
  }
  return isPagePath(p) ? p : '';
};

// Sanitize parameter values to prevent XSS and ensure valid URL encoding
export const sanitizeParam = (value) => {
  if (!value || typeof value !== 'string') return '';
  
  // Remove any potential script tags or dangerous characters
  const sanitized = value
    .replace(/<[^>]*>/g, '') // Remove HTML tags
    .replace(/['"]/g, '') // Remove quotes
    .replace(/[<>]/g, '') // Remove angle brackets
    .trim();
    
  // URL encode the value
  return encodeURIComponent(sanitized);
};

// Build register URL with UTM parameters.
// `extraParams` (optional object) appends additional query params, e.g.
// buildRegisterUrl(null, { draft: 'spd_x', name: 'Acme' })
export const buildRegisterUrl = (baseUrl, extraParams) => {
  // Always return static URL during SSR — cookies are not available and would cause
  // hydration mismatch if read during the first client render.
  if (typeof window === 'undefined') return baseUrl || 'https://app.hyperping.io/register';

  // Use localhost URL for development/localhost
  const isLocalhost = window.location.hostname === 'localhost' ||
                     window.location.hostname === '127.0.0.1' ||
                     window.location.hostname.includes('localhost');

  const defaultUrl = isLocalhost ? 'http://localhost:3200/#!/register' : 'https://app.hyperping.io/register';
  const finalBaseUrl = baseUrl || defaultUrl;

  const params = [];

  // Get UTM and referrer parameters from cookies
  const utmSource = getCookie('utm_source');
  const utmCampaign = getCookie('utm_campaign');
  const utmMedium = getCookie('utm_medium');
  const referrer = getCookie('referrer');
  const ref = getCookie('ref');
  const gclid = getCookie('gclid');

  // Add parameters if they exist and are valid
  if (utmSource) params.push(`utm_source=${sanitizeParam(utmSource)}`);
  if (utmCampaign) params.push(`utm_campaign=${sanitizeParam(utmCampaign)}`);
  if (utmMedium) params.push(`utm_medium=${sanitizeParam(utmMedium)}`);
  if (referrer) params.push(`referrer=${sanitizeParam(referrer)}`);
  if (ref) params.push(`ref=${sanitizeParam(ref)}`);
  // Google Ads click ID (set by gatsby-browser.js setCookies) — the app
  // stores it on the user at signup for offline conversion import.
  if (/^[\w-]{10,255}$/.test(gclid)) params.push(`gclid=${gclid}`);
  // Partner program referral code (cookie set by gatsby-browser.js setCookies
  // from ?via=, or by the server behind partners.hyperping.com/r/<code>) —
  // the app records the referral at signup.
  const via = getCookie('hp_via');
  if (isReferralCode(via)) params.push(`via=${via}`);

  // Funnel pages, stored on the user at signup (users.entryPage/exitPage):
  // entry = first page of the first visit (first-touch cookie set in
  // gatsby-browser setCookies), exit = the page hosting this CTA. Lets us
  // see which landing pages convert to paid, not just to click.
  const entryPage = getCookie('entry_page');
  if (isPagePath(entryPage)) params.push(`entry=${encodeURIComponent(entryPage)}`);
  const exitPage = getExitPage();
  if (exitPage) params.push(`exit=${encodeURIComponent(exitPage)}`);

  if (extraParams && typeof extraParams === 'object') {
    Object.keys(extraParams).forEach((key) => {
      const value = extraParams[key];
      if (value === undefined || value === null || value === '') return;
      // Lossless encoding on purpose: unlike the cookie-sourced UTM values
      // above, extra params carry user content (e.g. a status page name like
      // "Harry's") that the app escapes before display — sanitizeParam would
      // strip quotes/apostrophes and corrupt it.
      params.push(`${encodeURIComponent(key)}=${encodeURIComponent(String(value))}`);
    });
  }

  // Return URL with or without parameters (base may already carry a query string)
  const separator = finalBaseUrl.includes('?') ? '&' : '?';
  return params.length > 0 ? `${finalBaseUrl}${separator}${params.join('&')}` : finalBaseUrl;
};

// OAuth state parameter utilities for UTM tracking
export const base64UrlEncode = (str) => {
  return btoa(str).replace(/\+/g, '-').replace(/\//g, '_').replace(/=/g, '');
};

export const base64UrlDecode = (str) => {
  return atob(str.replace(/-/g, '+').replace(/_/g, '/'));
};

// Encode UTM parameters for OAuth state
export const encodeOAuthState = () => {
  const utmSource = getCookie('utm_source');
  const utmCampaign = getCookie('utm_campaign');
  const utmMedium = getCookie('utm_medium');
  const referrer = getCookie('referrer');
  
  const stateData = {};
  if (utmSource) stateData.utm_source = sanitizeParam(utmSource);
  if (utmCampaign) stateData.utm_campaign = sanitizeParam(utmCampaign);
  if (utmMedium) stateData.utm_medium = sanitizeParam(utmMedium);
  if (referrer) stateData.referrer = sanitizeParam(referrer);
  const gclid = getCookie('gclid');
  if (/^[\w-]{10,255}$/.test(gclid)) stateData.gclid = gclid;
  const via = getCookie('hp_via');
  if (isReferralCode(via)) stateData.via = via;

  // Same attribution as buildRegisterUrl — the OAuth state param is the only
  // bridge for the Google flow (no register URL involved). The app's login
  // controller passes the decoded state through as utmData; the server maps
  // entry/exit onto the user at creation.
  const entryPage = getCookie('entry_page');
  if (isPagePath(entryPage)) stateData.entry = entryPage;
  const exitPage = getExitPage();
  if (exitPage) stateData.exit = exitPage;

  return Object.keys(stateData).length > 0 
    ? base64UrlEncode(JSON.stringify(stateData))
    : '';
};

// Decode OAuth state parameter to get UTM data
export const decodeOAuthState = (stateParam) => {
  if (!stateParam) return {};
  
  try {
    const decoded = base64UrlDecode(stateParam);
    return JSON.parse(decoded);
  } catch (error) {
    console.warn('Failed to decode OAuth state parameter:', error);
    return {};
  }
};
